import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, Transition as _Transition, renderList as _renderList, TransitionGroup as _TransitionGroup } from "vue"
import _imports_0 from '@/assets/svg/hole_type2.svg'
import _imports_1 from '@/assets/svg/bm_type.svg'
import _imports_2 from '@/assets/svg/shape.svg'
import _imports_3 from '@/assets/svg/polygon_type.svg'


const _hoisted_1 = { class: "import-dialog-container" }
const _hoisted_2 = {
  key: 1,
  class: "import-dialog-inner"
}
const _hoisted_3 = { class: "import-dialog-title" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_7 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = { key: 8 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#aeaeae"} }, "/", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#aeaeae"} }, "/", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "import-dialog-content" }
const _hoisted_19 = {
  key: 0,
  class: "import-steps"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "import-step-badge" }, "1", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "import-step-badge" }, "2", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "import-step-badge" }, "3", -1)
const _hoisted_25 = {
  key: 0,
  class: "import-inputs animated-fast"
}
const _hoisted_26 = {
  style: {"margin-top":"15px"},
  class: "row"
}
const _hoisted_27 = {
  key: 0,
  style: {"margin-top":"15px"},
  class: "row"
}
const _hoisted_28 = {
  key: 1,
  class: "import-options"
}
const _hoisted_29 = { class: "row top" }
const _hoisted_30 = { class: "import-upload-container" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "add-menu" }
const _hoisted_35 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_36 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_40 = { class: "upload-file-item-details" }
const _hoisted_41 = { class: "upload-file-item-title" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "import-upload-container" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "add-menu" }
const _hoisted_50 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_51 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_55 = { class: "upload-file-item-details" }
const _hoisted_56 = { class: "upload-file-item-title" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "row" }
const _hoisted_61 = {
  key: 0,
  class: "row top"
}
const _hoisted_62 = { class: "import-upload-container" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = { class: "add-menu" }
const _hoisted_67 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_68 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_72 = { class: "upload-file-item-details" }
const _hoisted_73 = { class: "upload-file-item-title" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = { class: "import-upload-container" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = { class: "add-menu" }
const _hoisted_82 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_83 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_85 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_87 = { class: "upload-file-item-details" }
const _hoisted_88 = { class: "upload-file-item-title" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { style: {"margin-bottom":"0"} }
const _hoisted_93 = { class: "import-upload-container" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = { class: "add-menu" }
const _hoisted_98 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_99 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_101 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_103 = { class: "upload-file-item-details" }
const _hoisted_104 = { class: "upload-file-item-title" }
const _hoisted_105 = ["onClick"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { class: "import-upload-container" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = ["innerHTML"]
const _hoisted_112 = { class: "add-menu" }
const _hoisted_113 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_114 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_116 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_118 = { class: "upload-file-item-details" }
const _hoisted_119 = { class: "upload-file-item-title" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = {
  key: 2,
  class: "import-options"
}
const _hoisted_124 = { class: "row top" }
const _hoisted_125 = { class: "import-upload-container" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = ["innerHTML"]
const _hoisted_129 = { class: "add-menu" }
const _hoisted_130 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_131 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_133 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_135 = { class: "upload-file-item-details" }
const _hoisted_136 = { class: "upload-file-item-title" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = {
  key: 3,
  class: "import-options"
}
const _hoisted_141 = { class: "row top" }
const _hoisted_142 = { class: "import-upload-container" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = ["innerHTML"]
const _hoisted_146 = { class: "add-menu" }
const _hoisted_147 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_148 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_150 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_152 = { class: "upload-file-item-details" }
const _hoisted_153 = { class: "upload-file-item-title" }
const _hoisted_154 = ["onClick"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = {
  key: 4,
  class: "import-options"
}
const _hoisted_158 = { class: "row top" }
const _hoisted_159 = { class: "import-upload-container" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_161 = [
  _hoisted_160
]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("span", { innerHTML: `The point File to be uploaded` }, null, -1)
const _hoisted_163 = { class: "add-menu" }
const _hoisted_164 = {
  key: 0,
  class: "add-menu-dropdown animated-fast"
}
const _hoisted_165 = {
  key: 0,
  class: "upload-option-btns"
}
const _hoisted_166 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_167 = {
  key: 1,
  class: "upload-items"
}
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "upload-file-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-upload" })
], -1)
const _hoisted_169 = { class: "upload-file-item-details" }
const _hoisted_170 = { class: "upload-file-item-title" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_173 = [
  _hoisted_172
]
const _hoisted_174 = {
  key: 1,
  class: "import-inputs animated-fast"
}
const _hoisted_175 = {
  key: 0,
  class: "import-dialog-actions"
}
const _hoisted_176 = {
  key: 1,
  class: "import-dialog-actions"
}
const _hoisted_177 = {
  key: 2,
  class: "import-dialog-actions"
}
const _hoisted_178 = {
  key: 3,
  class: "import-dialog-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviouslyUploadedDialog = _resolveComponent("PreviouslyUploadedDialog")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_BlastDogImport = _resolveComponent("BlastDogImport")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_switch = _resolveComponent("imdex-switch")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_DatasetMapping = _resolveComponent("DatasetMapping")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_imdex_dialog, {
      width: "800",
      value: _ctx.previouslyUploadedDialog,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.previouslyUploadedDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PreviouslyUploadedDialog, {
          value: _ctx.previouslyUploadedDialog,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.previouslyUploadedDialog) = $event)),
          stagedFiles: [
					..._ctx.collarOptions.files,
					..._ctx.surveyOptions.files,
					..._ctx.plannedOptions.files,
					..._ctx.trajectoryOptions.files,
					..._ctx.intervalOptions.files,
					..._ctx.pointOptions.files,
					..._ctx.blockmodelOptions.files,
					..._ctx.shapeOptions.files,
					..._ctx.pointdataOptions.files
				],
          multiple: 
					_ctx.activeTypeForPreviouslyUploadedDialog == 'interval' ||
					_ctx.activeTypeForPreviouslyUploadedDialog == 'point'
				,
          onChange: _ctx.selectPreviousFiles,
          type: _ctx.type
        }, null, 8, ["value", "stagedFiles", "multiple", "onChange", "type"])
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.tempGroup.toLowerCase() == 'blastdog')
      ? (_openBlock(), _createBlock(_component_BlastDogImport, {
          key: 0,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
          setIsBlastDogDatasetInProgress: _ctx.importStore.setIsBlastDogDatasetInProgress,
          isBlastDogDatasetInProgress: _ctx.importStore.isBlastDogDatasetInProgress
        }, null, 8, ["setIsBlastDogDatasetInProgress", "isBlastDogDatasetInProgress"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.type == 'drillhole')
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.type == 'blockmodel')
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.type == 'shape')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.type == 'point')
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true),
            (
						_ctx.type == 'drillhole' &&
						_ctx.dataset_name == '' &&
						(!_ctx.includeFolderName || !_ctx.folderName)
					)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("import.uploadParent.createDh")), 1))
              : _createCommentVNode("", true),
            (
						_ctx.type == 'blockmodel' &&
						_ctx.dataset_name == '' &&
						(!_ctx.includeFolderName || !_ctx.folderName)
					)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("import.uploadParent.selectBM")), 1))
              : _createCommentVNode("", true),
            (
						_ctx.type == 'shape' && _ctx.dataset_name == '' && (!_ctx.includeFolderName || !_ctx.folderName)
					)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("import.uploadParent.selectShape")), 1))
              : _createCommentVNode("", true),
            (
						_ctx.type == 'point' && _ctx.dataset_name == '' && (!_ctx.includeFolderName || !_ctx.folderName)
					)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("import.uploadParent.selectPt")), 1))
              : _createCommentVNode("", true),
            (_ctx.dataset_name != '' || (_ctx.folderName != '' && _ctx.includeFolderName))
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.tempGroup) + " ", 1),
                  _hoisted_13,
                  (_ctx.folderName != '' && _ctx.includeFolderName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.folderName) + " ", 1),
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.dataset_name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.step == 0 && !_ctx.uploadingFiles)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 9,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close', false))),
                  class: "import-dialog-close"
                }, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.step != 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["import-step", { active: _ctx.step == 0 }])
                  }, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("import.uploadParent.step0")), 1)
                  ], 2),
                  (_ctx.type != 'blockmodel' && _ctx.type != 'shape')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_21,
                        _createElementVNode("div", {
                          class: _normalizeClass(["import-step", { active: _ctx.step == 1 }])
                        }, [
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("import.uploadParent.step1")), 1)
                        ], 2),
                        _hoisted_23,
                        _createElementVNode("div", {
                          class: _normalizeClass(["import-step", { active: _ctx.step == 2 }])
                        }, [
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("import.uploadParent.step2")), 1)
                        ], 2)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_TransitionGroup, {
              mode: "in-out",
              "enter-active-class": "fadeIn",
              "leave-active-class": "fadeOut"
            }, {
              default: _withCtx(() => [
                (!_ctx.uploadingFiles && !_ctx.uploadingDone && _ctx.step == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_imdex_text_field, {
                          style: {"max-width":"25%"},
                          value: _ctx.dataset_name,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataset_name) = $event)),
                          label: _ctx.$t(`import.uploadParent.dsNameLabel`)
                        }, null, 8, ["value", "label"]),
                        _createVNode(_component_imdex_select, {
                          label: _ctx.$t(`import.uploadParent.groupLabel`),
                          style: {"max-width":"25%"},
                          value: _ctx.tempGroup,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tempGroup) = $event)),
                          items: 
									_ctx.groups.map((item) => {
										return { text: item, value: item };
									})
								
                        }, null, 8, ["label", "value", "items"]),
                        _createVNode(_component_imdex_switch, {
                          value: _ctx.includeFolderName,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.includeFolderName) = $event))
                        }, null, 8, ["value"]),
                        _createVNode(_component_imdex_text_field, {
                          style: {"max-width":"25%"},
                          disabled: !_ctx.includeFolderName,
                          value: _ctx.folderName,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.folderName) = $event)),
                          label: _ctx.$t(`import.uploadParent.folderLabel`),
                          class: _normalizeClass({ error: _ctx.errors.folderName })
                        }, null, 8, ["disabled", "value", "label", "class"])
                      ]),
                      (_ctx.type == 'shape' && false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_openBlock(), _createBlock(_component_imdex_radio, {
                              key: 0,
                              value: _ctx.importAsMultiOrSingle,
                              val: 'single',
                              onInput: _cache[8] || (_cache[8] = 
									($event) => {
										_ctx.importAsMultiOrSingle = $event;
									}
								),
                              label: _ctx.$t(`import.uploadParent.asOneRadio`)
                            }, null, 8, ["value", "label"])),
                            (_openBlock(), _createBlock(_component_imdex_radio, {
                              key: 1,
                              value: _ctx.importAsMultiOrSingle,
                              val: 'multi',
                              onInput: _cache[9] || (_cache[9] = 
									($event) => {
										_ctx.importAsMultiOrSingle = $event;
									}
								),
                              label: _ctx.$t(`import.uploadParent.asSepRadio`)
                            }, null, 8, ["value", "label"]))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.type == 'drillhole')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhCollarFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_32, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: 
														_ctx.$t(`import.uploadParent.dhCollarTooltip`)
													
                                      }, null, 8, _hoisted_33)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("span", {
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (
													_ctx.collarOptions.addMenu = !_ctx.collarOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.collarOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.collarOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createElementVNode("div", {
                                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.browse('collar'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.dhSelectFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[12] || (_cache[12] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('collar')
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.collarOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "collarFileInput",
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectedFiles($event, 'collar'))),
                                    type: "file",
                                    accept: ".csv, .zip"
                                  }, null, 544),
                                  (_ctx.collarOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.browse('collar'))),
                                          id: "collar-browse",
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('collar'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_37,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collarOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_39,
                                            _createElementVNode("div", _hoisted_40, [
                                              _createElementVNode("div", _hoisted_41, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'collar')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_44, 8, _hoisted_42)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhSurveyFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_47, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.$t(`import.uploadParent.dhSurveyFile`)
                                      }, null, 8, _hoisted_48)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("span", {
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (
													_ctx.surveyOptions.addMenu = !_ctx.surveyOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.surveyOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.surveyOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                              _createElementVNode("div", {
                                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.browse('survey'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[18] || (_cache[18] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('survey')
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.surveyOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "surveyFileInput",
                                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectedFiles($event, 'survey'))),
                                    type: "file",
                                    accept: ".csv, .zip"
                                  }, null, 544),
                                  (_ctx.surveyOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.browse('survey'))),
                                          id: "survey-browse",
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('survey'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_52,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_54,
                                            _createElementVNode("div", _hoisted_55, [
                                              _createElementVNode("div", _hoisted_56, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'survey')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_59, 8, _hoisted_57)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_imdex_switch, {
                                label: "Include planned collars and trajectory",
                                value: _ctx.includePlanned,
                                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.includePlanned) = $event))
                              }, null, 8, ["value"])
                            ]),
                            (_ctx.includePlanned)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("h6", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhPlannedCollar`)) + " ", 1),
                                      _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                        activator: _withCtx((on) => [
                                          _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_64, 16)
                                        ]),
                                        tooltip: _withCtx(() => [
                                          _createElementVNode("span", {
                                            innerHTML: 
														_ctx.$t(`import.uploadParent.dhPlannedTooltip`)
													
                                          }, null, 8, _hoisted_65)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("span", {
                                          onClick: _cache[23] || (_cache[23] = ($event: any) => (
													_ctx.plannedOptions.addMenu = !_ctx.plannedOptions.addMenu
												))
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                          _createElementVNode("i", {
                                            class: _normalizeClass([{ open: _ctx.plannedOptions.addMenu }, "fal fa-angle-down"])
                                          }, null, 2)
                                        ]),
                                        _createVNode(_Transition, {
                                          "enter-active-class": "fadeInUp",
                                          "leave-active-class": "fadeOutDown"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.plannedOptions.addMenu)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                  _createElementVNode("div", {
                                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.browse('planned'))),
                                                    class: "add-menu-option"
                                                  }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                                  _createElementVNode("div", {
                                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('planned')
														)),
                                                    class: "add-menu-option"
                                                  }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["upload-box", { 'has-files': _ctx.plannedOptions.files.length > 0 }])
                                    }, [
                                      _createElementVNode("input", {
                                        ref: "plannedFileInput",
                                        onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedFiles($event, 'planned'))),
                                        type: "file",
                                        accept: ".csv, .zip"
                                      }, null, 544),
                                      (_ctx.plannedOptions.files.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                            _createVNode(_component_imdex_btn, {
                                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.browse('planned'))),
                                              id: "planned-browse",
                                              compact: "",
                                              secondary: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                            _createVNode(_component_imdex_btn, {
                                              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('planned'))),
                                              secondary: "",
                                              compact: "",
                                              text: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                                _hoisted_69,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plannedOptions.files, (file, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                                key: i
                                              }, [
                                                _hoisted_71,
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createElementVNode("div", _hoisted_73, _toDisplayString(file.name), 1),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                  onClick: ($event: any) => (_ctx.removeFile(file.name, 'planned')),
                                                  class: "upload-file-item-close"
                                                }, _hoisted_76, 8, _hoisted_74)
                                              ], 2))
                                            }), 128))
                                          ]))
                                    ], 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("h6", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhTrajFile`)) + " ", 1),
                                      _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                        activator: _withCtx((on) => [
                                          _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_79, 16)
                                        ]),
                                        tooltip: _withCtx(() => [
                                          _createElementVNode("span", {
                                            innerHTML: _ctx.$t(`import.uploadParent.dhTrajTooltip`)
                                          }, null, 8, _hoisted_80)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("span", {
                                          onClick: _cache[29] || (_cache[29] = ($event: any) => (
													_ctx.trajectoryOptions.addMenu =
														!_ctx.trajectoryOptions.addMenu
												))
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                          _createElementVNode("i", {
                                            class: _normalizeClass([{ open: _ctx.trajectoryOptions.addMenu }, "fal fa-angle-down"])
                                          }, null, 2)
                                        ]),
                                        _createVNode(_Transition, {
                                          "enter-active-class": "fadeInUp",
                                          "leave-active-class": "fadeOutDown"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.trajectoryOptions.addMenu)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                  _createElementVNode("div", {
                                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.browse('trajectory'))),
                                                    class: "add-menu-option"
                                                  }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                                  _createElementVNode("div", {
                                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog(
																'trajectory'
															)
														)),
                                                    class: "add-menu-option"
                                                  }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["upload-box", { 'has-files': _ctx.trajectoryOptions.files.length > 0 }])
                                    }, [
                                      _createElementVNode("input", {
                                        ref: "trajectoryFileInput",
                                        onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectedFiles($event, 'trajectory'))),
                                        type: "file",
                                        accept: ".csv, .zip"
                                      }, null, 544),
                                      (_ctx.trajectoryOptions.files.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                            _createVNode(_component_imdex_btn, {
                                              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.browse('trajectory'))),
                                              id: "trajectory-browse",
                                              compact: "",
                                              secondary: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                            _createVNode(_component_imdex_btn, {
                                              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('trajectory'))),
                                              secondary: "",
                                              compact: "",
                                              text: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                                _hoisted_84,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trajectoryOptions.files, (file, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                                key: i
                                              }, [
                                                _hoisted_86,
                                                _createElementVNode("div", _hoisted_87, [
                                                  _createElementVNode("div", _hoisted_88, _toDisplayString(file.name), 1),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                  onClick: ($event: any) => (_ctx.removeFile(file.name, 'trajectory')),
                                                  class: "upload-file-item-close"
                                                }, _hoisted_91, 8, _hoisted_89)
                                              ], 2))
                                            }), 128))
                                          ]))
                                    ], 2)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_92, _toDisplayString(_ctx.$t(`import.uploadParent.propFiles`)), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["row top", {
									'files-disabled':
										_ctx.collarOptions.files.length == 0 ||
										_ctx.surveyOptions.files.length == 0
								}])
                            }, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhIntFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_95, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.$t(`import.uploadParent.dhIntTooltip`)
                                      }, null, 8, _hoisted_96)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("span", {
                                      onClick: _cache[35] || (_cache[35] = ($event: any) => (
													_ctx.intervalOptions.addMenu =
														!_ctx.intervalOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.intervalOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.intervalOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                              _createElementVNode("div", {
                                                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.browse('interval'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[37] || (_cache[37] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('interval')
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.intervalOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "intervalFileInput",
                                    onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.selectedFiles($event, 'interval'))),
                                    multiple: "",
                                    type: "file",
                                    accept: ".csv, .zip"
                                  }, null, 544),
                                  (_ctx.intervalOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.browse('interval'))),
                                          id: "interval-browse",
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('interval'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_100,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervalOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_102,
                                            _createElementVNode("div", _hoisted_103, [
                                              _createElementVNode("div", _hoisted_104, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'interval')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_107, 8, _hoisted_105)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ]),
                              _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.dhPointFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_110, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: 
														_ctx.$t(`import.uploadParent.dhPointTooltip`)
													
                                      }, null, 8, _hoisted_111)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("span", {
                                      onClick: _cache[41] || (_cache[41] = ($event: any) => (
													_ctx.pointOptions.addMenu = !_ctx.pointOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.pointOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.pointOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                              _createElementVNode("div", {
                                                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.browse('point'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[43] || (_cache[43] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('point')
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.pointOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "pointFileInput",
                                    onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.selectedFiles($event, 'point'))),
                                    multiple: "",
                                    type: "file",
                                    accept: ".csv, .zip"
                                  }, null, 544),
                                  (_ctx.pointOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.browse('point'))),
                                          id: "point-browse",
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('point'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_115,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_117,
                                            _createElementVNode("div", _hoisted_118, [
                                              _createElementVNode("div", _hoisted_119, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'point')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_122, 8, _hoisted_120)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ])
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.type == 'blockmodel')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.bmFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_127, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.$t(`import.uploadParent.bmTooltip`)
                                      }, null, 8, _hoisted_128)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_129, [
                                    _createElementVNode("span", {
                                      onClick: _cache[47] || (_cache[47] = ($event: any) => (
													_ctx.blockmodelOptions.addMenu =
														!_ctx.blockmodelOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.blockmodelOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.blockmodelOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                              _createElementVNode("div", {
                                                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.browse('blockmodel'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[49] || (_cache[49] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog(
																'blockmodel'
															)
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.blockmodelOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "blockmodelFileInput",
                                    onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.selectedFiles($event, 'blockmodel'))),
                                    multiple: "",
                                    type: "file",
                                    accept: ".dat, .dm, .csv, .zip"
                                  }, null, 544),
                                  (_ctx.blockmodelOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.browse('blockmodel'))),
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('blockmodel'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_132,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockmodelOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_134,
                                            _createElementVNode("div", _hoisted_135, [
                                              _createElementVNode("div", _hoisted_136, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'blockmodel')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_139, 8, _hoisted_137)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.type == 'shape')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                            _createElementVNode("div", _hoisted_141, [
                              _createElementVNode("div", _hoisted_142, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.shapeFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_144, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.$t(`import.uploadParent.shapeTooltip`)
                                      }, null, 8, _hoisted_145)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_146, [
                                    _createElementVNode("span", {
                                      onClick: _cache[53] || (_cache[53] = ($event: any) => (
													_ctx.shapeOptions.addMenu = !_ctx.shapeOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.shapeOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.shapeOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                              _createElementVNode("div", {
                                                onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.browse('shape'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[55] || (_cache[55] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog('shape')
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.shapeOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "shapeFileInput",
                                    onChange: _cache[56] || (_cache[56] = ($event: any) => (_ctx.selectedFiles($event, 'shape'))),
                                    multiple: "",
                                    type: "file",
                                    accept: ".dxf, .zip"
                                  }, null, 544),
                                  (_ctx.shapeOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.browse('shape'))),
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('shape'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_149,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shapeOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_151,
                                            _createElementVNode("div", _hoisted_152, [
                                              _createElementVNode("div", _hoisted_153, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'shape')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_156, 8, _hoisted_154)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.type == 'point')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                            _createElementVNode("div", _hoisted_158, [
                              _createElementVNode("div", _hoisted_159, [
                                _createElementVNode("h6", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.pointFile`)) + " ", 1),
                                  _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_161, 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _hoisted_162
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_163, [
                                    _createElementVNode("span", {
                                      onClick: _cache[59] || (_cache[59] = ($event: any) => (
													_ctx.pointdataOptions.addMenu =
														!_ctx.pointdataOptions.addMenu
												))
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.addBtn`)) + " ", 1),
                                      _createElementVNode("i", {
                                        class: _normalizeClass([{ open: _ctx.pointdataOptions.addMenu }, "fal fa-angle-down"])
                                      }, null, 2)
                                    ]),
                                    _createVNode(_Transition, {
                                      "enter-active-class": "fadeInUp",
                                      "leave-active-class": "fadeOutDown"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.pointdataOptions.addMenu)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                              _createElementVNode("div", {
                                                onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.browse('pointdata'))),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(`import.uploadParent.uploadFiles`)), 1),
                                              _createElementVNode("div", {
                                                onClick: _cache[61] || (_cache[61] = ($event: any) => (
															_ctx.showPreviouslyUploadedDialog(
																'pointdata'
															)
														)),
                                                class: "add-menu-option"
                                              }, _toDisplayString(_ctx.$t(
																`import.uploadParent.usePreviouslyUploaded`
															)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["upload-box", { 'has-files': _ctx.pointdataOptions.files.length > 0 }])
                                }, [
                                  _createElementVNode("input", {
                                    ref: "pointdataFileInput",
                                    onChange: _cache[62] || (_cache[62] = ($event: any) => (_ctx.selectedFiles($event, 'pointdata'))),
                                    multiple: "",
                                    type: "file",
                                    accept: ".csv, .zip, .gas"
                                  }, null, 544),
                                  (_ctx.pointdataOptions.files.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.browse('pointdata'))),
                                          compact: "",
                                          secondary: "",
                                          outlined: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.browse`)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`import.uploadParent.or`)), 1),
                                        _createVNode(_component_imdex_btn, {
                                          onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.showPreviouslyUploadedDialog('pointdata'))),
                                          secondary: "",
                                          compact: "",
                                          text: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.usePreviously`)), 1),
                                            _hoisted_166,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`import.uploadParent.uploadedFile`)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointdataOptions.files, (file, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["upload-file-item", { error: file.hasError }]),
                                            key: i
                                          }, [
                                            _hoisted_168,
                                            _createElementVNode("div", _hoisted_169, [
                                              _createElementVNode("div", _hoisted_170, _toDisplayString(file.name), 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)) + "    " + _toDisplayString(file.status ||
															_ctx.$t(`import.uploadParent.notYetUploaded`)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.removeFile(file.name, 'pointdata')),
                                              class: "upload-file-item-close"
                                            }, _hoisted_173, 8, _hoisted_171)
                                          ], 2))
                                        }), 128))
                                      ]))
                                ], 2)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.uploadingFiles && _ctx.step == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                      _createVNode(_component_UploadFiles, {
                        ref: "uploadFiles",
                        datasetName: _ctx.dataset_name,
                        onCancel: _cache[65] || (_cache[65] = ($event: any) => (_ctx.uploadingFiles = false)),
                        onFinished: _cache[66] || (_cache[66] = ($event) => _ctx.finishUploadingFiles($event)),
                        filesToUpload: _ctx.filesToUpload,
                        groupName: _ctx.tempGroup,
                        folderPath: _ctx.folderName
                      }, null, 8, ["datasetName", "filesToUpload", "groupName", "folderPath"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step == 1)
                  ? (_openBlock(), _createBlock(_component_DatasetMapping, {
                      key: 2,
                      onCancel: _cache[67] || (_cache[67] = ($event: any) => ((_ctx.uploadingFiles = false), (_ctx.uploadingDone = false), (_ctx.step = 0))),
                      type: _ctx.type,
                      maps: _ctx.finishedDatasetMaps,
                      meta: _ctx.meta,
                      onFinished: _cache[68] || (_cache[68] = ($event: any) => (_ctx.$emit('close')))
                    }, null, 8, ["type", "maps", "meta"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (!_ctx.uploadingFiles)
            ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                _createVNode(_component_imdex_btn, {
                  onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.$emit('close', false))),
                  small: "",
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.cancelBtn`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_imdex_btn, {
                  onClick: _ctx.beginUploadFiles,
                  disabled: 
						Number(_ctx.filesReady) <=
							Number(
								_ctx.intervalOptions.files.length > 0 || _ctx.pointOptions.files.length > 0
									? 1
									: 0
							) ||
						_ctx.dataset_name == '' ||
						_ctx.tempGroup == '' ||
						!_ctx.dataset_name.replace(/\s/g, '').length ||
						(_ctx.includeFolderName
							? _ctx.folderName == '' || !_ctx.folderName.replace(/\s/g, '').length
							: false)
					,
                  small: "",
                  secondary: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.step0`)), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadingFiles && !_ctx.uploadingDone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                _createVNode(_component_imdex_btn, {
                  onClick: _ctx.cancelUpload,
                  small: "",
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.cancelBtn`)), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (
					_ctx.uploadingDone &&
					_ctx.step == 0 &&
					(_ctx.type == 'drillhole' || _ctx.type == 'point' || _ctx.type == 'blockmodel')
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                _createVNode(_component_imdex_btn, {
                  onClick: _ctx.beginMapDataset,
                  small: "",
                  secondary: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.step1`)), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadingDone && _ctx.step == 0 && _ctx.type == 'shape')
            ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                _createVNode(_component_imdex_btn, {
                  onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.$emit('close', false))),
                  small: "",
                  secondary: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`import.uploadParent.doneBtn`)), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}